import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAll = createAsyncThunk(
    "masters/chant/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Masters.Chant}?term=${filter?.name || ""}&chant_type_id=${filter?.chant_type_id || ""
                }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE
                }`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// GetSingle a specific chant
export const GetSingle = createAsyncThunk(
    "masters/chant/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Masters.Chant}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create a new chant
export const Create = createAsyncThunk(
    "masters/chant/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(APIS.Masters.Chant, data);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            console.log(error, "error chant");
            return rejectWithValue(error);
        }
    }
);
// Update a chant
export const Update = createAsyncThunk(
    "masters/chant/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.Masters.Chant}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
// Delete a chant
export const Delete = createAsyncThunk(
    "masters/chant/delete",
    async (id, { rejectWithValue }) => {
        try {
            await DELETE(`${APIS.Masters.Chant}/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Change the status of a chant
export const Status = createAsyncThunk(
    "masters/chant/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.Chant}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "chant",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetAll.pending, (chant) => {
                chant.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Succeeded;
                chant.data = action.payload?.data?.data || [];
                chant.current_page = action.payload?.data?.current_page || IDS.PAGE;
                chant.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                chant.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                chant.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Failed;
                chant.error = action.payload;
            })
            .addCase(GetSingle.pending, (chant) => {
                chant.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Failed;
                chant.error = action.payload;
            })
            .addCase(Create.pending, (chant) => {
                chant.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Succeeded;
                // chant.data = action.payload;
                chant.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Failed;
                chant.error = action.payload;
            })
            .addCase(Update.pending, (chant) => {
                chant.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Succeeded;
                const index = chant.data.findIndex(
                    (stateItem) => stateItem.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    chant.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Failed;
                chant.error = action.payload;
            })
            .addCase(Delete.pending, (chant) => {
                chant.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Succeeded;
                // chant.data = chant.data.filter(
                //   (stateItem) => stateItem.id !== action.payload
                // );
                chant.data = chant.data.filter(
                    (stateItem) => stateItem.id !== action.payload
                );
            })
            .addCase(Delete.rejected, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Failed;
                chant.error = action.payload;
            })
            .addCase(Status.pending, (chant) => {
                chant.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Succeeded;
                const index = chant.data.findIndex(
                    (stateItem) => stateItem.id === action.payload?.id
                );
                if (index !== -1) {
                    chant.data[index].status = !chant.data[index].status;
                }
            })
            .addCase(Status.rejected, (chant, action) => {
                chant.status = IDS.SLICESTATUS.Failed;
                chant.error = action.payload;
            });
    },
});

export default Slice.reducer;
